import {useQueries} from "@tanstack/react-query";
import projectService from "../../../services/project-service";
import resalesService from "../../../services/resales-service";
import nocService from "../../../services/noc-service";

const UseContactsFetchData = () => {
    const queries = useQueries({
        queries: [
            {
                queryFn: () => projectService.listContacts().then(({data}) => data),
                queryKey: ["contacts"],
            },
            {
                queryFn: () => projectService.options().then(({data}) => data),
                queryKey: ["projects"]
            },
            {
                queryFn: () => resalesService.options().then(({data}) => data.filter(v => v.value !== 1)),
                queryKey: ["resales", "options"]
            },
            {
                queryFn: () => nocService.getHash().then(({data}) => data),
                queryKey: ["hash"]
            }
        ]
    });

    return {
        contactsFetch: queries[0].data,
        projects: queries[1].data,
        resales: queries[2].data,
        hash: queries[3].data
    }
};

export default UseContactsFetchData;
